import { createThunkRequest, POST } from '@webapp/account/src/libs/request';
import { getFilterParams } from '@webapp/account/src/resources/lib';
import { selectReportsList } from '@webapp/account/src/resources/reports';

import { undefDestroy } from '@webapp/common/lib/utils';

import { mapTask } from './map';
import type { TaskCreateProps } from './task';
import { TaskLocalStatus, TaskType } from './task';

function requestFactory(
    {
        fileType,
        globalFilters,
        questions,
        surveyId,
        taskType,
        onlyTestScore,
        pageScores,
        linkId,
        lang,
        ...rest
    }: TaskCreateProps,
    state,
): any {
    switch (taskType) {
        case TaskType.PDF:
            const { path } = rest.params;
            const domain = location.hostname;
            const filters = encodeURIComponent(JSON.stringify(globalFilters));

            return POST(
                'order/pdf_result',
                undefDestroy({
                    domain,
                    linkId,
                    path,
                    filters,
                    lang,
                    survey: surveyId,
                }) as any,
            );
        default:
            questions = questions || []; // TODO wtf

            const reports = selectReportsList(state);
            const filterParams = getFilterParams(globalFilters, reports);
            const { audio } = rest;
            const withExcluded = globalFilters.excludedQuestionIds.size > 0;
            const questionsFinal = withExcluded
                ? questions.filter((questionId) => !globalFilters.excludedQuestionIds.has(questionId))
                : questions;

            return POST(
                'orders',
                undefDestroy({
                    ...filterParams,
                    hidden_questions: Array.from(globalFilters.excludedQuestionIds),
                    audio,
                    survey: surveyId,
                    limit: 100,
                    type: fileType,
                    lang,
                    order_type: taskType,
                    onlyTestScore,
                    pageScores,
                    ...(questionsFinal.length ? { question: questionsFinal.join(',') } : {}),
                }),
            );
    }
}

export const createTask = createThunkRequest(
    'tasks/createTask',
    async (data: TaskCreateProps, { getState }) => {
        const { uuid } = data;
        const state = getState();

        try {
            const { id } = await requestFactory(data, state);

            return {
                id,
                uuid,
            };
        } catch ({ message }) {
            return {
                status: TaskLocalStatus.ERROR,
                uuid,
            };
        }
    },
    { notify: false, notifyError: true },
);

export const addWaiting = createThunkRequest('tasks/addWaiting', ({ task, uuid }) => {
    return { task, uuid };
});

export const showOrders = createThunkRequest(
    'tasks/showOrders',
    async (data: { id: Array<number>; limit: number }) => {
        const { rows } = await POST('show/orders', data);

        return { tasks: rows.map(mapTask) };
    },
    { notify: false, notifyError: true },
);
